export default "__VITE_ASSET__C_9BT5iZ__"